export const locations = {
  sculptureFalls: {
    name: "Sculpture Falls",
    address: "1710 Camp Craft Road",
    info: "You can also visit the Hill of Life from here.",
    locationID: "08155240"
  },
  twinFalls: {
    name: "Twin Falls",
    address: "3918 S. Mopac Expy",
    info:
      "From Capital of Texas Highway, turn as if you're heading south on Mopac but stay on the feeder and park along the frontage.",
    locationID: "08155300"
  },
  loop360: {
    name: "360 Loop",
    address: "3755-B Capital of Texas Hwy (Loop 360)",
    info: "There's great climbing here.",
    locationID: "08155300"
  },
  gusFruh: {
    name: "Gus Fruh",
    address: "2642 Barton Hills Dr",
    info: "This is my favorite swimming hole.",
    locationID: "08155400"
  },
  spyglass: {
    name: "Spyglass",
    address: "1601 Spyglass Dr",
    info:
      "Grab a bite at TacoDeli after you swim! You can access Campbell's Hole if you head north on the trail",
    locationID: "08155400"
  },
  campbellsHole: {
    name: "Campbell's Hole",
    address: "2010 Homedale Dr",
    info:
      "You can access Campbell's Hole from the east side of the creek from Barton Hills Elementary School.",
    locationID: "08155400"
  },
  aboveBarton: {
    name: "Above Barton Springs",
    address: "2201 Barton Springs Rd",
    info:
      "Near the Zilker Park playground and right next to Barton Springs Pool.",
    locationID: "08155400"
  },
  lostCreek: {
    name: "Lost Creek",
    address: "Lost Creek Blvd & Bend Of The River Dr",
    info:
      "This entrance is tricky. Merge onto 360 N from 290 W and turn left onto Lost Creek Blvd. The trail entrance is underneath the bridge.",
    locationID: "08155240"
  }
};

export const gaugeLocations = {
  "08155240": "lostCreek",
  "08155300": "loop360",
  "08155400": "aboveBarton"
};
